import "./number.js"

Date.fromString = function(str) {
	return new Date(str + 'T00:00:00');
}

Date.getMondayOfCurrentWeek = function() {
   const date = new Date();
   date.setDate(date.getDate() - date.getWeekday());
   return date;
}

Date.prototype.getWeekNumber = function(){
   var d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
   var dayNum = d.getUTCDay() || 7;
   d.setUTCDate(d.getUTCDate() + 4 - dayNum);
   var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
   return Math.ceil((((d - yearStart) / 86400000) + 1)/7)
 };

Date.prototype.isoDate = function() {
   return this.getFullYear() + '-' + (this.getMonth()+1).pad(2) + '-' + this.getDate().pad(2);
};

Date.prototype.nextDay = function(ofWeekdays) {
   this.setDate(this.getDate()+1);
   if (ofWeekdays && [0,1,2,3,4,5,6].filter(x => ofWeekdays.includes(x)).length > 0) {
      while (!ofWeekdays.includes(this.getWeekday())) this.nextDay();
   }
};

Date.prototype.prevDay = function(ofWeekdays) {
   this.setDate(this.getDate()-1);
   if (ofWeekdays && [0,1,2,3,4,5,6].filter(x => ofWeekdays.includes(x)).length > 0) {
      while (!ofWeekdays.includes(this.getWeekday())) this.prevDay();
   }
};

Date.prototype.isSameDay = function(date) {

   return this.getFullYear() === date.getFullYear() &&
          this.getMonth() === date.getMonth() &&
          this.getDate() === date.getDate();

}

Date.prototype.getWeekday = function() {
   return (this.getDay() + 6) % 7;
};

Date.prototype.toGermanDate = function(withWeekdays, fullWeekdays) {

   let val = '';
   if (withWeekdays) {
      val += Date.getGermanWeekday((this.getDay()+6)%7, fullWeekdays) + ', ';
   }
   return val + `${this.getDate().pad(2)}.${(this.getMonth()+1).pad(2)}.${this.getFullYear()}`;

};

Date.getGermanWeekday = function(weekday, full) {

   if (full) return ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"][weekday];
   else return ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'][weekday];

};

Date.prototype.getMonthRange = function(cntMonths) {

   let date = new Date(Date.fromString(this.isoDate()));

   date.setDate(1);
   let from = new Date(date);
   date.setMonth(date.getMonth() + cntMonths, 0);
   return { from: from, to: date };

};

Date.prototype.getNextMonth = function(cntMonths) {
   let m = new Date(this);
   m.setMonth(m.getMonth() + 1, 1);
   return m;
};

Date.prototype.getGermanMonthName = function() {

   return Date.getGermanMonth(this.getMonth(), true);
   //return ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"][this.getMonth()];

};

Date.getGermanMonth = function(index, full) {
   if (full)
      return ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"][index];
   else
      return ["Jan.", "Feb.", "März", "Apr.", "Mai", "Jun.", "Jul.", "Aug.", "Sept.", "Okt.", "Nov.", "Dez."][index];
};

Date.prototype.inTimespan = function(from, to) {

   return this.isoDate() >= new Date(from).isoDate() && this.isoDate() <= new Date(to).isoDate();

};

Date.simplifyDatePeriod = function(usDate1, usDate2) {

   if (usDate1 == usDate2) return new Date(Date.fromString(usDate1)).toGermanDate();

   let d1 = usDate1.split('-');
   let d2 = usDate2.split('-');

   let newDate1 = '';
   let newDate2 = '';

   // ungleiches Jahr: jeweils komplettes Datum nötig.
   if (d1[0] != d2[0]) return new Date(Date.fromString(usDate1)).toGermanDate() + '-' + new Date(Date.fromString(usDate2)).toGermanDate();

   if (d1[1] != d2[1]) return d1[2] + '.' + d1[1] + '-' + d2[2] + '.' + d2[1] + '.' + d1[0];
   if (d1[2] != d2[2]) return d1[2] + '.' + '-' + d2[2] + '.' + d2[1] + '.' + d1[0];

   //return germanDate(usDate1);
   return new Date(Date.fromString(usDate1)).toGermanDate();

};


Date.prototype.format = function(format) {
   let str = "";
   let percent = false;
   for (let i=0; i<format.length; ++i) {
      let ch = format[i];

      if (ch == '%') {
         percent = true;
         continue;
      }

      if (percent) {
         percent = false;
         switch (format[i]) {
            case 'd':   // Tag
               str +=  (this.getDate() < 10 ? '0' : '') + this.getDate();
               break;
            case 'm':   // Monat
               str += (this.getMonth() < 9 ? '0' : '') + (this.getMonth() + 1);
               break;
            case 'Y':   // Jahr
               str += this.getFullYear();
               break;
            case 'H':   // Tag
               str += (this.getHours() < 10 ? '0' : '') + this.getHours();
               break;
            case 'i':   // Tag
               str += (this.getMinutes() < 10 ? '0' : '') + this.getMinutes();
               break;
            case 's':   // Tag
               str += (this.getSeconds() < 10 ? '0' : '') + this.getSeconds();
               break;
            case '%':
               str += '%';
               break;
            default:
               str += format[i];
         }
      }
      else {
         str += ch;
      }
   }

   return str;

};
